import lazyLoadView from '@router/lazy-loader'
import ContainerView from './views/main'
import configs from './config'

const routePrefix = configs.routePrefix

const moduleName = configs.name

const routeNamePrefix = configs.routeNamePrefix

export default [
  {
    path: `${routePrefix}`,
    component: ContainerView,
    meta: { moduleName, breadcrumbKey: 'patch_management' },
    children: [
      {
        path: '',
        name: routeNamePrefix,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "registry-template" */ './views/list')
          ),
        meta: {
          breadcrumbKey: 'registry_template',
        },
      },
      {
        path: 'create',
        name: `${routeNamePrefix}.create`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "registry-template" */ './views/create')
          ),
        meta: {},
      },
      {
        path: 'edit/:id',
        name: `${routeNamePrefix}.edit`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "registry-template" */ './views/edit')
          ),
        meta: {},
      },
    ],
  },
]
